import React, { Component } from "react";
import BackWithSearch from "../../Elements/BackWithSearch";
import ContentLoader from "react-content-loader";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { setFavoriteRest } from "../../../../services/items/actions";
import { IMAGES_URL } from "../../../../configs/website";
import DeliveryTime from "../../DeliveryTime";
import {
  Modal,
  Box,
  Tabs,
  Tab,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import { FaMoneyBillWave, FaCreditCard } from "react-icons/fa";

class MerchantInfo extends Component {
  state = {
    withLinkToMerchant: false,
    isFavorite: false,
    BackBarBG: false,
    isModalOpen: false,
    selectedTab: 0,
  };

  componentDidMount() {
    this.setState({ withLinkToMerchant: this.props.withLinkToMerchant });

    if (
      this.props.history.location.state &&
      this.props.history.location.state.fromExplorePage
    ) {
      this.setState({
        withLinkToMerchant: this.props.history.location.state.fromExplorePage,
      });
    }

    this.registerScrollEvent();
  }

  componentWillUnmount() {
    this.removeScrollEvent();
  }

  fixedMerchantInfo = (hidden) => {
    if (this.child) {
      if (hidden) {
        this.child.heading.classList.add("hidden");
      } else {
        this.child.heading.classList.remove("hidden");
      }
    }
  };

  registerScrollEvent() {
    window.addEventListener("scroll", this.scrollFunc);
  }

  removeScrollEvent() {
    window.removeEventListener("scroll", this.scrollFunc);
  }

  scrollFunc = () => {
    if (document.documentElement.scrollTop > 180) {
      this.fixedMerchantInfo(false);
      this.setState({ BackBarBG: true });
    }
    if (document.documentElement.scrollTop < 180) {
      this.fixedMerchantInfo(true);
      this.setState({ BackBarBG: false });
    }
  };

  setFavoriteMerchant = () => {
    const { merchant_info, user } = this.props;
    if (user.success) {
      this.props.setFavoriteRest(user.data.auth_token, merchant_info.id);
    }
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.merchant_info !== prevState.merchant_info) {
      return {
        data: nextProps.merchant_info,
      };
    } else {
      return null;
    }
  }

  toggleModal = () => {
    this.setState((prevState) => ({ isModalOpen: !prevState.isModalOpen }));
  };

  handleTabChange = (event, newValue) => {
    this.setState({ selectedTab: newValue });
  };

  // Mascara para telefone
  formatPhone(phone) {
    // Remove qualquer caractere não numérico
    const cleaned = phone.replace(/\D/g, "");
    console.log("Cleaned phone:", cleaned); // Verifique a saída aqui

    // Remove o código do país (assumindo que é '55' para todos os números)
    const numberWithoutCountryCode = cleaned.startsWith("55")
      ? cleaned.slice(2)
      : cleaned;

    // Verifica se o número possui 10 ou 11 dígitos
    if (numberWithoutCountryCode.length === 10) {
      // Para número com 10 dígitos, a máscara será (00) 0000-0000
      return `+55 ${numberWithoutCountryCode.slice(
        0,
        2
      )} ${numberWithoutCountryCode.slice(
        2,
        6
      )}-${numberWithoutCountryCode.slice(6)}`;
    } else if (numberWithoutCountryCode.length === 11) {
      // Para número com 11 dígitos, a máscara será (00) 00000-0000
      return `+55 ${numberWithoutCountryCode.slice(
        0,
        2
      )} ${numberWithoutCountryCode.slice(
        2,
        7
      )}-${numberWithoutCountryCode.slice(7)}`;
    }

    // Retorna a string limpa ou um aviso se o formato estiver errado
    console.log("Invalid phone format, returning original:", phone); // Diagnóstico
    return phone;
  }

  PaymentGateways = ({ payment_gateways_active }) => {
    // Filtrando apenas os gateways ativos
    if (payment_gateways_active && payment_gateways_active.length > 0) {
      const activeGateways = payment_gateways_active.filter(
        (gateway) => gateway.is_active === 1
      );

      return (
        <div style={{ padding: "16px", maxWidth: "400px", margin: "0 auto" }}>
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: "bold",
              marginBottom: "8px",
              fontSize: "1rem",
              textAlign: "center",
            }}
          >
            Métodos de Pagamento Aceitos
          </Typography>
          <List style={{ padding: 0 }}>
            {activeGateways.map((gateway) => (
              <ListItem
                key={gateway.id}
                style={{
                  padding: "1px 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {/* Ícone de cartão ou dinheiro dependendo do tipo */}
                {gateway.type === "credit" || gateway.type === "debit" ? (
                  <FaCreditCard
                    style={{ marginRight: "10px", color: "#FF8003" }}
                  />
                ) : (
                  <FaMoneyBillWave
                    style={{ marginRight: "10px", color: "#FF8003" }}
                  />
                )}
                <ListItemText
                  primary={gateway.name}
                  style={{ marginLeft: "8px", fontSize: "0.875rem" }}
                />
              </ListItem>
            ))}
          </List>
        </div>
      );
    } else {
      return;
    }
  };

  render() {
    const { history, merchant, user } = this.props;
    const { isModalOpen, selectedTab } = this.state;
    const isClosed = merchant.delivery_type === 0;

    // Registra o último merchant aberto
    localStorage.setItem("lastMerchantOpen", merchant.id);

    return (
      <React.Fragment>
        <div className="bg-white">
          <BackWithSearch
            ref={(node) => {
              this.child = node;
            }}
            history={history}
            boxshadow={false}
            has_merchant_info={true}
            merchant={merchant}
            disable_search={true}
            homeButton={false}
            merchantWhats={merchant.whatsapp}
            shareButton={true}
            colorBG={this.state.BackBarBG}
            favoriteButton={user.success === true ? true : false}
            favoriteAction={this.setFavoriteMerchant}
            favoriteMerchant={merchant.is_favorited}
          />

          {merchant.length === 0 ? (
            <ContentLoader
              height={170}
              width={400}
              speed={1.2}
              primaryColor="#f3f3f3"
              secondaryColor="#ecebeb"
            >
              <rect x="20" y="70" rx="4" ry="4" width="80" height="78" />
              <rect x="144" y="85" rx="0" ry="0" width="115" height="18" />
              <rect x="144" y="115" rx="0" ry="0" width="165" height="16" />
            </ContentLoader>
          ) : (
            <React.Fragment>
              <div>
                <div
                  className="col-24 bg-cover"
                  style={{
                    backgroundImage: `url(${
                      IMAGES_URL + merchant.cover + "/public"
                    })`,
                  }}
                />
                <div className="d-flex pt-10">
                  <div className="px-15 mt-5">
                    <img
                      src={IMAGES_URL + merchant.image + "/public"}
                      alt={merchant.name}
                      className="merchant-image mt-0"
                      width={"45px"}
                      height={"45px"}
                    />
                  </div>
                  <div
                    className="mt-5 pb-15 w-100"
                    style={{ maxWidth: "75vw" }}
                  >
                    <h4 className="font-w600 mb-5 text-dark">
                      {merchant.name}
                    </h4>
                    <div className="font-size-sm text-muted">
                      <div className="truncate-text">
                        {merchant.description}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "5px",
                          color: "#F7691E",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.toggleModal();
                        }}
                      >
                        <span>Ver mais</span>
                      </div>
                    </div>
                    {merchant.is_pureveg === 1 && (
                      <p className="mb-0">
                        <span className="font-size-sm pr-1 text-muted">
                          {localStorage.getItem("pureVegText")}
                        </span>
                        <img
                          src="/assets/img/various/pure-veg.png"
                          alt="PureVeg"
                          style={{ width: "20px" }}
                        />
                      </p>
                    )}
                    <div className="text-center merchant-meta mt-5 d-flex align-items-center justify-content-between text-muted">
                      {merchant.avgRating === "0" ? (
                        <div className="col-2 p-0 text-left">
                          <i
                            className="fa fa-star"
                            style={{
                              color: localStorage.getItem("storeColor"),
                            }}
                          />{" "}
                          {merchant.rating}
                        </div>
                      ) : (
                        <Link
                          to={"/reviews/" + merchant.slug}
                          style={{ display: "contents" }}
                          className="yes-click"
                        >
                          <div className="col-2 p-0 text-left store-rating-block">
                            <i
                              className="fa fa-star"
                              style={{
                                color: localStorage.getItem("storeColor"),
                              }}
                            />{" "}
                            {merchant.avgRating}
                          </div>
                        </Link>
                      )}
                      <div className="col-4 p-0 text-center store-distance-block">
                        <i className="si si-clock" />{" "}
                        <DeliveryTime rate_and_time={merchant.rate_and_time} />
                      </div>
                      <div className="col-6 p-0 text-center store-avgprice-block">
                        <i className="si si-wallet" />{" "}
                        {localStorage.getItem("currencySymbolAlign") ===
                          "left" && (
                          <React.Fragment>
                            {localStorage.getItem("currencyFormat")}
                            {parseInt(merchant.min_order_price)}{" "}
                          </React.Fragment>
                        )}
                        {localStorage.getItem("currencySymbolAlign") ===
                          "right" && (
                          <React.Fragment>
                            {parseInt(merchant.min_order_price)}
                            {localStorage.getItem("currencyFormat")}{" "}
                          </React.Fragment>
                        )}
                        {localStorage.getItem("homePageForTwoText")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>

        {isModalOpen && (
          <Modal
            open={isModalOpen}
            onClose={this.toggleModal}
            aria-labelledby="merchant-modal"
            aria-describedby="merchant-info"
          >
            <Box
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "95%",
                maxWidth: "400px",
                backgroundColor: "#fff",
                borderRadius: "8px",
                padding: "20px",
                outline: "none",
              }}
            >
              <Tabs
                value={selectedTab}
                onChange={this.handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                centered
              >
                <Tab label="Informações" />
                <Tab label="Horário de Funcionamento" />
              </Tabs>
              {selectedTab === 0 && (
                <Box mt={2}>
                  {/* Informações do merchant */}
                  <Typography variant="h6">
                    {merchant.name || "Nome não disponível"}
                  </Typography>
                  <Typography variant="body1">
                    {merchant.description || "Descrição não disponível"}
                  </Typography>
                  {merchant.cnpj && (
                    <Typography variant="body1">
                      CNPJ: {merchant.cnpj}
                    </Typography>
                  )}
                  <Typography variant="body1">
                    Endereço:{" "}
                    {merchant.address
                      ? `${merchant.address.street || ""} ${
                          merchant.address.number || ""
                        }, ${merchant.address.district || ""} - ${
                          merchant.address.city || ""
                        } ${merchant.address.state || ""} - ${
                          merchant.address.cep || ""
                        }`
                      : "Endereço não disponível"}
                  </Typography>
                  <Typography variant="body1">
                    Contato:{" "}
                    {merchant.phone
                      ? this.formatPhone(merchant.phone)
                      : "Não informado"}
                  </Typography>

                  {this.PaymentGateways(merchant)}
                </Box>
              )}
              {selectedTab === 1 && (
                <Box mt={2}>
                  {(() => {
                    const daysOfWeek = [
                      "domingo",
                      "segunda",
                      "terça",
                      "quarta",
                      "quinta",
                      "sexta",
                      "sábado",
                    ];
                    const scheduleData = JSON.parse(merchant.schedule_data);
                    return (
                      <div>
                        {Object.entries(scheduleData).map(
                          ([day, schedules]) => {
                            const dayIndex =
                              Object.keys(scheduleData).indexOf(day);
                            const translatedDay = daysOfWeek[dayIndex];
                            return (
                              <div key={day} style={{ marginBottom: "10px" }}>
                                <strong>{translatedDay}:</strong>
                                {schedules.map((schedule, index) => (
                                  <span key={index}>
                                    {` ${schedule.open} - ${schedule.close}`}
                                  </span>
                                ))}
                              </div>
                            );
                          }
                        )}
                      </div>
                    );
                  })()}
                </Box>
              )}
            </Box>
          </Modal>
        )}
        {isClosed && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 10000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                padding: "20px",
                backgroundColor: "#fff",
                borderRadius: "8px",
                textAlign: "center",
              }}
            >
              <h4>
                Atenção!{" "}
                <span role="img" aria-label="warning">
                  🚨
                </span>
              </h4>
              <p>No momento, a loja não está aceitando pedidos.</p>
              <p>
                Isso pode ser temporário devido à alta demanda ou outros ajustes
                operacionais.
              </p>
              <p>Tente novamente mais tarde!</p>
              <span role="img" aria-label="smiling face with smiling eyes">
                😊
              </span>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  merchant_info: state.items.merchant_info,
  user: state.user.user,
});

export default connect(mapStateToProps, { setFavoriteRest })(MerchantInfo);
